import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as styles from './performance-overview.scss';
import { Typography } from 'carbon-react/lib/components/typography/typography.component';

interface PeriodOption {
  name: string;
  value: string;
}

interface PeriodToggleProps {
  options: PeriodOption[];
  selectedValue: string;
  onChange: (value: string) => void;
}

export const PeriodToggle = ({ options, selectedValue, onChange }: PeriodToggleProps) => {
  return (
    <div>
      <Typography fontSize="16px" fontWeight="500" lineHeight="140%" mb={1}>
        <FormattedMessage id="predict.performance_overview.period_shown" defaultMessage="Period shown" />
      </Typography>
      <div className={styles.periodToggleGroup}>
        {options.map(option => {
          const isActive = option.value === selectedValue;
          return (
            <button
              key={option.value}
              type="button"
              className={`${styles.periodToggleButton} ${isActive ? styles.periodToggleButtonActive : ''}`}
              onClick={() => {
                if (!isActive) {
                  onChange(option.value);
                }
              }}
            >
              {option.name}
            </button>
          );
        })}
      </div>
    </div>
  );
};
